<template>
	<div
		class="btn-group"
		:class="{
			group: this.separated
		}"
	>
		<slot />
	</div>
</template>

<script>
export default {
	props: {
		separated: {
			type: Boolean
		}
	}
}
</script>

<style scoped>
.group > button:not(:last-child) {
	margin-right: 6px !important;
}
.group > button {
	border-radius: 3px !important;
}
@media (max-width: 1024px) {
	.group {
		width: 100%;
	}
	.group > button {
		margin-right: 0px !important;
		margin-left: 0px !important;
	}
	button {
		margin-bottom: 6px;
	}
}
</style>
